import {HOST, DOMAIN, UPLOAD} from '@/utils/base';
import {pinyin} from 'pinyin-pro';
import {saveAs} from 'file-saver';
import * as XLSX from 'xlsx';

export default function (Vue, options) {
    // HOST
    Vue.prototype.vmHost = HOST;
    Vue.prototype.upload = UPLOAD;

    // IframeHost
    Vue.prototype.vmIframeHost = function (HostCurrent) {
        if (process.env.NODE_ENV == 'development') {
            let str = HostCurrent.host;
            return 'http://' + DOMAIN + ':' + str.substring(str.length - 4);
        } else {
            return 'https://' + DOMAIN;
        }
    };

    // 判断手机号是否合法
    Vue.prototype.validatePhone = function (value) {
        return !/^1[3|4|5|7|8][0-9]\d{8}$/.test(value);
    };

    // 对Date的扩展，将 Date 转化为指定格式的String
    // 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
    // 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
    // 例子：
    // (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
    // (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
    Date.prototype.Format = function (fmt) {
        var weeks = ['日', '一', '二', '三', '四', '五', '六'];
        var o = {
            'M+': this.getMonth() + 1, //月份
            'd+': this.getDate(), //日
            'h+': this.getHours(), //小时
            'm+': this.getMinutes(), //分
            's+': this.getSeconds(), //秒
            'q+': Math.floor((this.getMonth() + 3) / 3), //季度
            S: this.getMilliseconds(), //毫秒
            W: weeks[this.getDay()], //星期
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        return fmt;
    };
    Vue.prototype.isValidJSON = function (text) {
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    };

    /**
     * 获取地理位置和城市信息
     */
    Vue.prototype.Geolocation = function () {
        const self = this;
        const ins = setInterval(() => {
            if (window.BMap && BMap.Geolocation) {
                clearInterval(ins);
                if (self.$store.state.app.Citylist.length == 0) {
                    const geolocation = new BMap.Geolocation();
                    geolocation.getCurrentPosition(
                        function (r) {
                            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                                self.$store.dispatch('app/getCitiesByType', {type: 2, cityname: r.address.city});
                            } else {
                                alert('failed' + this.getStatus());
                            }
                        },
                        {enableHighAccuracy: true}
                    );
                }
            }
        }, 500);
    };

    /**
     * 数组比较大小
     * @param {*} prop
     * @param {*} reserve
     */
    function arrayCompare(prop, reserve = 'id') {
        return (a, b) => {
            let v1 = a[prop];
            let v2 = b[prop];
            return v1 != v2 ? v1 - v2 : a[reserve] - b[reserve];
        };
    }

    /**
     * 数组排序
     * @param {*} arr
     */
    Vue.prototype.arraySort = arr => {
        arr.sort(arrayCompare('sort'));
        arr.forEach(v => {
            if (v.children && v.children.length > 1) {
                Vue.prototype.arraySort(v.children);
            }
        });
    };

    /**
     *
     * 判断是否有按钮权限
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.checkBtnPermission = function (data) {
        if (!data) return true;
        const BtnPermissions = window.IMS_API.btnPermissions;
        if (typeof data === 'string') {
            return BtnPermissions.indexOf(data) !== -1;
        } else if (Array.isArray(data)) {
            let d = data.filter(v => BtnPermissions.indexOf(v.btnKey) !== -1);
            return d;
        }
    };

    Vue.prototype.getApproveStatus = function (approve, type) {
        let status = approve;
        //审批状态 0待提交1已提交2已审核5驳回
        if (status == 0) {
            return "<span   style='color:gray;font-size:12px'>未审核</span>";
        } else {
            return "<span   style='color:blue;font-size:12px'>已审核</span>";
        }
    };
    /**
     *
     * 判断状态
     * @param {*} data String||Array(btnKey)
     * return Boolean || Array
     */
    Vue.prototype.getStatus = function (status) {
        if (status == 0) {
            return "<span  style='color:red;font-size:12px'>禁用</span>";
        } else if (status == 1) {
            return "<span  style='color:green;font-size:12px'>启用</span>";
        } else {
            return "<span  style='color:gray;font-size:12px'>禁言</span>";
        }
    };

    Vue.prototype.notify = function (message, type = 1) {
        this.$notify({
            title: '提示',
            message: message,
            type: type == 1 ? 'success' : 'error',
        });
    };

    Vue.prototype.goPage = function (url) {
        window.top.IMS_ACTIONS.renderIframe(url);
    };

    Vue.prototype.exportToExcel = function (jsonData, excelFileName) {
        // 将JSON数据转换为Sheet
        const ws = XLSX.utils.json_to_sheet(jsonData);

        // 创建工作簿并添加Sheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // 生成Excel文件
        const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

        const buf = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== wbout.length; ++i) view[i] = wbout.charCodeAt(i) & 0xff;
        // 创建二进制对象并创建url
        const blob = new Blob([buf], {type: 'application/octet-stream'});
        const url = URL.createObjectURL(blob);

        // 创建a标签模拟点击进行下载
        const a = document.createElement('a');
        a.href = url;
        a.download = excelFileName + '.xlsx';
        document.body.appendChild(a);
        a.click();
        // 清除临时的url和标签
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    // 编码emoji表情：把utf16代理对字符转换成 &#xxxx; 实体字符以供后台存储（与小程序 glbfunction.transEmoji 一致）
    Vue.prototype.transEmoji = function (str) {
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g;
        return str.replace(patt, function (char) {
            var H, L, code;
            if (char.length === 2) {
                H = char.charCodeAt(0);
                L = char.charCodeAt(1);
                code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00;
                return '&#' + code + ';';
            } else {
                return char;
            }
        });
    };

    // 解码emoji表情
    Vue.prototype.transToEmoji = function (str) {
        var reg = /\&#.*?;/g;
        var result = str.replace(reg, function (char) {
            var H, L, code;
            if (char.length == 9) {
                code = parseInt(char.match(/[0-9]+/g));
                H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
                L = ((code - 0x10000) % 0x400) + 0xdc00;
                return unescape('%u' + H.toString(16) + '%u' + L.toString(16));
            } else {
                return char;
            }
        });
        return result;
    };
}



// WEBPACK FOOTER //
// ./src/utils/vm.prototype.js